import { ScreenSpinner } from '@vkontakte/vkui';
import '@vkontakte/vkui/dist/vkui.css';
import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { $activePanel, setActivePanel } from 'src/entity/ActivePanel';
import { $message, clearMessage } from 'src/entity/Messages';
import { $isPostCardPreparing } from 'src/entity/PostCard';
import { $isStandAlone } from 'src/entity/User';
import { $isPosting } from 'src/features/postVotes';
import { GateProvider } from './providers/GateProvider';
import { ModalProvider } from './providers/ModalProvider';
import { RouteProvider } from './providers/RouteProvider';
import { AppPanels } from './providers/RouteProvider/lib/routeConfig';
import './styles/index.scss';

export const App = () => {
  const [
    activePanel,
    message,
    onClearMessage,
    isPosting,
    isStandAlone,
    onSetActivePanel,
    isPostCardPreparing
  ] = useUnit([
    $activePanel,
    $message,
    clearMessage,
    $isPosting,
    $isStandAlone,
    setActivePanel,
    $isPostCardPreparing
  ]);

  useEffect(() => {
    if (isStandAlone) {
      onSetActivePanel(AppPanels.SECOND_STAGE_NOMINATIONS);
    }
  }, [isStandAlone, onSetActivePanel]);

  return (
    <>
      <GateProvider />
      <RouteProvider
        activePanel={activePanel}
      />
      <ModalProvider
        messageType={message}
        onClose={onClearMessage}
      />
      {(isPosting || isPostCardPreparing) && <ScreenSpinner />}
    </>
  );
};
